import keyBy from 'lodash/keyBy';
import { rejected, resolved } from '../../createAction';
import {
  GET_ARTICLE,
  GET_POST,
  LOAD_BLOGS,
  LOAD_COMPARE,
  LOAD_DISCOUNT,
  UPDATE_CART,
} from './types';

const initialState = {
  compare: {
    loading: false,
  },
  discount: {
    loading: false,
  },
  cart: {},
  blogs: {
    loading: false,
    postIds: [],
    page: 0,
    entities: {},
  },
  articles: {},
};

const blogReducer = (state, action) => {
  const { type, payload, meta } = action;
  switch (type) {
    case LOAD_BLOGS: {
      return {
        ...state,
        loading: true,
      };
    }
    case resolved(LOAD_BLOGS): {
      return {
        ...state,
        postIds: payload.map((i) => i.post_permalink),
        entities: keyBy(payload, 'post_permalink'),
        page: meta.page,
        loading: false,
      };
    }
    case rejected(LOAD_BLOGS): {
      return {
        ...state,
        loading: false,
      };
    }
    case resolved(GET_POST): {
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.post_permalink]: payload,
        },
      };
    }
  }
};

export default (state = initialState, action) => {
  const { type, payload, meta } = action;
  switch (type) {
    case LOAD_COMPARE:
      return {
        ...state,
        compare: {
          ...state.compare,
          loading: true,
        },
      };
    case resolved(LOAD_COMPARE):
      return {
        ...state,
        compare: {
          ...state.compare,
          loading: false,
          [meta.cat + meta.type]: payload,
        },
      };
    case LOAD_DISCOUNT:
      return {
        ...state,
        discount: {
          ...state.discount,
          loading: true,
        },
      };
    case resolved(LOAD_DISCOUNT):
      return {
        ...state,
        discount: {
          ...state.discount,
          loading: false,
          [meta.type]: payload,
        },
      };
    case UPDATE_CART:
      return {
        ...state,
        cart: { ...payload },
      };
    case LOAD_BLOGS:
    case rejected(LOAD_BLOGS):
    case resolved(LOAD_BLOGS): {
      return {
        ...state,
        blogs: blogReducer(state.blogs, action),
      };
    }
    case resolved(GET_POST): {
      return {
        ...state,
        blogs: blogReducer(state.blogs, action),
      };
    }
    case GET_ARTICLE: {
      return {
        ...state,
        articles: {
          ...state.articles,
          loading: true,
        },
      };
    }
    case resolved(GET_ARTICLE): {
      return {
        ...state,
        articles: {
          ...state.articles,
          loading: false,
          [meta.type]: payload,
        },
      };
    }
    default:
      return state;
  }
};
